<template>
  <svg
    width="256"
    height="180"
    viewBox="0 0 256 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M252.605 35.8963C249.211 13.8547 237.46 8.43776 227.732 5.11488C218.004 1.792 169.738 0 128 0C86.2618 0 37.9955 1.792 28.2675 5.11488C18.5395 8.43776 6.79423 13.8547 3.39455 35.8963C-1.31836e-05 57.9379 0 84.736 0 89.5795C0 94.423 -1.31836e-05 121.221 3.39455 143.263C6.78911 165.304 18.5395 170.721 28.2675 174.044C37.9955 177.367 86.2618 179.159 128 179.159C169.738 179.159 218.004 177.367 227.732 174.044C237.46 170.721 249.211 165.304 252.605 143.263C256 121.221 256 94.423 256 89.5795C256 84.736 256 57.9379 252.605 35.8963Z"
      fill="#FF0000"
    />
    <path d="M102.067 50.7544V89.3336V127.913L169.211 89.3336L102.067 50.7544Z" fill="white" />
  </svg>
</template>

<script>
export default {
  name: 'Youtube',
};
</script>
